let gfFormTrackingBound = false;

const pushedKeys = {};

const pushFormSubmission = (tracking) => {
    if (!tracking || !tracking.formID) {
        return;
    }

    const key = String(tracking.entryId || tracking.formID);
    if (pushedKeys[key] || (window.__gfGtmPushed && window.__gfGtmPushed[key])) {
        return;
    }

    pushedKeys[key] = true;
    window.__gfGtmPushed = window.__gfGtmPushed || {};
    window.__gfGtmPushed[key] = 1;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'formSubmission',
        formID: tracking.formID,
        nom: tracking.nom || '',
        prenom: tracking.prenom || '',
        email: tracking.email || '',
        telephone: tracking.telephone || '',
        entreprise: tracking.entreprise || '',
    });

    setTimeout(() => {
        delete pushedKeys[key];
    }, 10000);
};

const readPayloadFromConfirmation = (formId) => {
    const wrapper = document.getElementById(`gform_confirmation_wrapper_${formId}`);
    const raw = wrapper?.getAttribute('data-gf-gtm-payload');

    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch (error) {
        return null;
    }
};

const pushFromAjaxResult = (data) => {
    pushFormSubmission(data?.submissionResult?.data?.gtm_form_submission);
    return data;
};

const registerGfAjaxHooks = () => {
    if (!window.gform?.utils?.addFilter) {
        return;
    }

    window.gform.utils.addFilter('gform/ajax/post_submission_request', pushFromAjaxResult);
    window.gform.utils.addFilter('gform/ajax/post_ajax_submission', pushFromAjaxResult);
};

const bindLegacyListeners = () => {
    jQuery(document).on('gform_confirmation_loaded.gfFormTracking', (event, formId) => {
        pushFormSubmission(readPayloadFromConfirmation(formId));
    });
};

/**
 * Tracking GTM formSubmission — tous modes GF :
 * - AJAX fetch (message + redirect) : gtm_form_submission via post_submission_request
 * - iframe AJAX (message) : script PHP + gform_confirmation_loaded
 * - iframe AJAX (redirect) : script PHP avant gformRedirect()
 * - postback (message + redirect) : script PHP dans la page
 */
const initGfFormTracking = () => {
    if (gfFormTrackingBound || typeof jQuery === 'undefined') {
        return;
    }
    gfFormTrackingBound = true;

    bindLegacyListeners();

    if (window.gform?.initializeOnLoaded) {
        window.gform.initializeOnLoaded(registerGfAjaxHooks);
    } else {
        registerGfAjaxHooks();
    }
};

export { initGfFormTracking };
